import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
} from "components/ui/card";
import { Skeleton } from "components/ui/skeleton";

interface UsageCardProps {
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  totalCredits?: number;
}

export const UsageCard = ({
  isError,
  isLoading,
  isSuccess,
  totalCredits,
}: UsageCardProps) => (
  <Card className="min-w-0 col-span-2 md:col-span-1">
    {isError && (
      <CardHeader className="">
        <CardDescription>Total Credits</CardDescription>
      </CardHeader>
    )}

    {isLoading && (
      <CardHeader className="">
        <Skeleton className="h-8" />
      </CardHeader>
    )}

    {isSuccess && totalCredits !== undefined && (
      <CardHeader className="">
        <CardTitle>
          {totalCredits.toLocaleString("en-US", { minimumFractionDigits: 1 })}
        </CardTitle>
        <CardDescription>Total Credits</CardDescription>
      </CardHeader>
    )}
  </Card>
);
